__turbopack_context__.v({
  "multiLine": "Underline-module-scss-module__Ax_JLq__multiLine",
  "singleLine": "Underline-module-scss-module__Ax_JLq__singleLine",
  "svgUnderline": "Underline-module-scss-module__Ax_JLq__svgUnderline",
});
